<template>
    <div>
        <div v-if="loading" class="lds-spinner">
            <div />            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
        }
    },
    created() {
        // delete token from server (oauth_clients table)
        this.$store.dispatch('destroyToken')
            .then(() => {
                this.loading = false
                this.$router.push({name: 'Home'})
            })
    },
}
</script>